import styled from "styled-components";
import Icon360 from '../../icons/Icon360.svg?react';
import { useState } from 'react';

interface ViewItemProps {
    view: string;
    selected: boolean;
    thumbnail: string;
    onClick: () => void;
}

const ViewItem : React.FC<ViewItemProps> = ({view, selected, thumbnail, onClick}) => {

    const is360View = view === "360";
    const [imageLoaded, setImageLoaded] = useState(false);

    return (
        <Container onClick={onClick}>
            <ThumbnailWrapper>
                <ViewThumbnail 
                    src={thumbnail} 
                    alt={"VUE " + view}
                    onLoad={() => setImageLoaded(true)}
                />
                {is360View && imageLoaded && <Overlay />}
            </ThumbnailWrapper>
            {is360View && <StyledIcon360/>}
            <ViewTitle>VUE {view}</ViewTitle>
        </Container>
    )
}

const Container = styled.div`
    position: relative;
    flex: 1;
    min-height: 0;
    display: flex;
    width: fit-content;
    color: white;
    text-align: center;
    padding: .6vh .6vw;
    margin-bottom: 1vh;
    border-radius: 5px 0 0 5px;
    transition: .3s ease-in-out;
    opacity: 1;
    background-color: ${props => props.theme.colors.viewItemBackground};
    &:hover{
        cursor: pointer;
        opacity: .9;
        background-color: ${props => props.theme.colors.viewItemHoverBackground};
    }
`;

const ThumbnailWrapper = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    height: 100%;
    border-radius: 3px;
`;

const ViewThumbnail = styled.img`
    // display: flex;
    height: 100%;
    object-fit: contain;
    aspect-ratio: 16 / 9;
`;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.colors.panoramicViewBackground};
`;

const StyledIcon360 = styled(Icon360)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -65%);
    width: 40%;
    height: auto;
`;

const ViewTitle = styled.div`
    position: absolute;
    bottom: 0;
    text-align: center;
    width: calc(100% - 1.2vw);
    margin-bottom: 1.0vh;
    font-family: Poppins-ExtraBold, sans-serif;
    font-size: 14px;
    
`;

export default ViewItem;